import React from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

export const FacilityColumns = (handleEdit, handleDelete) => {
    return [
        {
            field: 'name',
            headerName: 'FacilityName',
            minWidth: 300,
            sortable: true,
        },
        {
            field: 'address',
            headerName: 'Address',
            minWidth: 150,
            flex: 2,
            sortable: false,

        },
        {
            field: 'city',
            headerName: 'City',
            minWidth: 100,
            sortable: false,

        },
        {
            field: 'state_name',
            headerName: 'State',
            minWidth: 100,
            sortable: false,

        },
        {
            field: 'zip',
            headerName: 'zip',
            minWidth: 100,
            sortable: false,

        },

        {
            field: 'contact',
            headerName: 'Contact',
            minWidth: 150,
            sortable: false,

        },
        {
            field: 'phone_number',
            headerName: 'PhoneNumber',
            minWidth: 150,
            sortable: false,

        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            align: 'right',
            renderCell: (params) => (
                <div>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <ModeEditIcon className='ml-5 edit-color' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                        <DeleteIcon className='ml-5 delete-color' />
                    </IconButton>
                </div>
            ),
        },
    ];
};
